// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#app:not(.isTouchDevice) .cursor-pointer[data-v-419f6794]:hover{cursor:pointer}[data-v-419f6794] .client-underline{border-bottom:1px solid #e40028}.content-color[data-v-419f6794]{color:#535353}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
